/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KinnserPatient } from './KinnserPatient';
import {
    KinnserPatientFromJSON,
    KinnserPatientFromJSONTyped,
    KinnserPatientToJSON,
    KinnserPatientToJSONTyped,
} from './KinnserPatient';

/**
 * 
 * @export
 * @interface GetKinnserPatient200Response
 */
export interface GetKinnserPatient200Response {
    /**
     * 
     */
    data?: KinnserPatient;
}

/**
 * Check if a given object implements the GetKinnserPatient200Response interface.
 */
export function instanceOfGetKinnserPatient200Response(value: object): value is GetKinnserPatient200Response {
    return true;
}

export function GetKinnserPatient200ResponseFromJSON(json: any): GetKinnserPatient200Response {
    return GetKinnserPatient200ResponseFromJSONTyped(json, false);
}

export function GetKinnserPatient200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKinnserPatient200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : KinnserPatientFromJSON(json['data']),
    };
}

export function GetKinnserPatient200ResponseToJSON(json: any): GetKinnserPatient200Response {
    return GetKinnserPatient200ResponseToJSONTyped(json, false);
}

export function GetKinnserPatient200ResponseToJSONTyped(value?: GetKinnserPatient200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': KinnserPatientToJSON(value['data']),
    };
}

